/*
  Clara Hamptons – cart drawer.
  Loaded synchronously (before the deferred theme.js) so it can take over Impulse's
  theme.cart, theme.CartDrawer and theme.AjaxProduct before the theme boots.
  The drawer markup is rendered by Liquid (snippets/clara-cart-contents.liquid). Add/change
  requests ask Shopify to return that section in the same response (Section Rendering API),
  so the drawer opens once with final prices – no second render, no flicker.
*/
(function() {
var theme = window.theme = window.theme || {};
if (theme.__claraCart) { return; }
theme.__claraCart = true;

function jq() { return theme.jQuery || window.jQuery; }

var cartExtensions = {
  sectionId: 'clara-cart-drawer',

  sectionsUrl: function() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + '?sections=' + this.sectionId;
  },

  sectionParams: function() {
    return 'sections=' + encodeURIComponent(this.sectionId) +
      '&sections_url=' + encodeURIComponent(window.location.pathname);
  },

  changeItem: function(key, qty) {
    return jq().ajax({
      type: 'POST',
      url: theme.routes.cartChange + '.js',
      data: 'quantity=' + encodeURIComponent(qty) + '&id=' + encodeURIComponent(key) + '&' + this.sectionParams(),
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return jq().ajax({
      type: 'POST',
      url: theme.routes.cartAdd,
      data: data + '&' + this.sectionParams(),
      dataType: 'json'
    });
  }
};

function extendCart(obj) {
  for (var k in cartExtensions) { obj[k] = cartExtensions[k]; }
}

var built = null;
function build() {
  if (built) { return built; }
  var $ = jq();

  var CartDrawer = (function() {
    // Clara: the drawer is rendered by Liquid (snippets/clara-cart-contents.liquid).
    // Add/change requests ask Shopify to return the re-rendered section in the same
    // response (Section Rendering API), so the drawer updates in one step, without
    // intermediate states, extra product fetches or price flicker.
    var config = {
      namespace: '.ajaxcart'
    };

    var selectors = {
      drawer: '#CartDrawer',
      container: '#CartContainer',
      cartBubble: '.cart-link__bubble',
      count: '[data-clara-cart-count]'
    };

    function CartDrawer() {
      this.status = {
        loaded: true,
        loading: false
      };
      this.requestId = 0;

      this.drawer = new theme.Drawers('CartDrawer', 'cart');
      theme.cartDrawer = this;

      this.initEventListeners();
      this.afterRender();

      // Page restored from the back/forward cache: cart may have changed in another page.
      window.addEventListener('pageshow', function(evt) {
        if (evt.persisted) { this.refresh(false); }
      }.bind(this));
    };

    CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
      initEventListeners: function() {
        var $body = $('body');
        // Re-initialising the header in the theme editor must not stack handlers.
        $body.off('.claraCart');

        $body.on('added.ajaxProduct.claraCart', function(evt, returnFocusEl, html) {
          if (html) {
            this.render(html, true, returnFocusEl);
          } else {
            this.refresh(true, returnFocusEl);
          }
        }.bind(this));

        $body.on('qty.cart-drawer.claraCart', this.updateItem.bind(this));

        $body.on('click.claraCart', selectors.drawer + ' .clara-cart-remove', function(evt) {
          evt.preventDefault();
          this.updateItem(null, $(evt.currentTarget).data('key'), 0);
        }.bind(this));
      },

      // Replace the drawer contents with freshly rendered section HTML.
      render: function(html, openDrawer, returnFocusEl) {
        var $container = $(selectors.container);
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var section = wrapper.querySelector('.shopify-section') || wrapper;

        $container.html(section.innerHTML);
        this.afterRender();

        if (openDrawer === true) {
          this.drawer.open(false, returnFocusEl);
        }
      },

      afterRender: function() {
        this.initQtySelectors();

        var count = parseInt($(selectors.container).find(selectors.count).attr('data-clara-cart-count'), 10) || 0;
        $(selectors.cartBubble).toggleClass('cart-link__bubble--visible', count > 0);

        $('body').trigger('updateCart' + config.namespace, { item_count: count });

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      // Fetch the rendered drawer without changing the cart.
      refresh: function(openDrawer, returnFocusEl) {
        var id = ++this.requestId;
        return $.ajax({
          type: 'GET',
          url: theme.cart.sectionsUrl(),
          dataType: 'json',
          cache: false
        }).then(function(sections) {
          if (id !== this.requestId) { return; }
          this.render(sections[theme.cart.sectionId], openDrawer, returnFocusEl);
        }.bind(this));
      },

      initQtySelectors: function() {
        $(selectors.container).find('.js-qty__wrapper').each(function(index, el) {
          new theme.QtySelector($(el), {
            namespace: '.cart-drawer'
          });
        });
      },

      updateItem: function(evt, key, qty) {
        if (this.status.loading || !key) {
          return;
        }

        this.loading(true);
        var id = ++this.requestId;

        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            if (id !== this.requestId) { return; }
            if (cart && cart.sections && cart.sections[theme.cart.sectionId]) {
              this.render(cart.sections[theme.cart.sectionId]);
            } else {
              this.refresh(false);
            }
          }.bind(this), function(XMLHttpRequest) {
            this.updateError(XMLHttpRequest);
          }.bind(this))
          .always(function() {
            this.loading(false);
          }.bind(this));
      },

      loading: function(state) {
        this.status.loading = state;
        $(selectors.container).toggleClass('is-loading', !!state);
      },

      updateError: function(XMLHttpRequest) {
        var message = XMLHttpRequest && XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description;
        // Restore the real quantities, then show why the change was refused (e.g. stock limit).
        this.refresh(false).then(function() {
          if (!message) { return; }
          var $msg = $('<p class="clara-cart-error" role="alert"></p>').text(message);
          $(selectors.container).find('.drawer__scrollable').prepend($msg);
        });
      }
    });

    return CartDrawer;
  })();

  var AjaxProduct = (function() {
    var status = {
      loading: false
    };

    function ProductForm($form) {
      this.$form = $form;
      this.$addToCart = this.$form.find('.add-to-cart');

      if (this.$form.length) {
        this.$form.on('submit', this.addItemFromForm.bind(this));
      }
    };

    ProductForm.prototype = $.extend({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // No ajax drawer (cart page mode): let the form post normally.
        if (!theme.cartDrawer) {
          this.$form.off('submit');
          this.$form.trigger('submit');
          return;
        }

        this.$addToCart.addClass('btn--loading').attr('aria-busy', 'true');
        status.loading = true;

        var data = this.$form.serialize();

        theme.cart.addItemFromForm(data)
          .then(function(product) {
            this.success(product);
          }.bind(this), function(XMLHttpRequest) {
            this.error(XMLHttpRequest);
          }.bind(this))
          .always(function() {
            status.loading = false;
            this.$addToCart.removeClass('btn--loading').removeAttr('aria-busy');
          }.bind(this));
      },

      success: function(product) {
        this.$form.find('.errors').remove();
        var html = product && product.sections ? product.sections[theme.cart.sectionId] : null;
        $('body').trigger('added.ajaxProduct', [this.$addToCart[0], html]);
      },

      error: function(XMLHttpRequest) {
        this.$form.find('.errors').remove();

        var message = XMLHttpRequest && XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description;
        if (message) {
          this.$form.prepend($('<div class="errors text-center" role="alert"></div>').text(message));
        }
      }
    });

    return ProductForm;
  })();

  built = { CartDrawer: CartDrawer, AjaxProduct: AjaxProduct };
  return built;
}

// When theme.js assigns its own versions, keep ours.
function takeOver(name) {
  var assigned = false;
  Object.defineProperty(theme, name, {
    configurable: true,
    enumerable: true,
    get: function() { return assigned ? build()[name] : undefined; },
    set: function() { assigned = true; }
  });
}

var cartObject = theme.cart;
if (cartObject) { extendCart(cartObject); }
Object.defineProperty(theme, 'cart', {
  configurable: true,
  enumerable: true,
  get: function() { return cartObject; },
  set: function(value) {
    cartObject = value;
    if (value) { extendCart(value); }
  }
});

if (theme.CartDrawer || theme.AjaxProduct) {
  // theme.js already ran (should not happen): replace directly.
  var b = build();
  theme.CartDrawer = b.CartDrawer;
  theme.AjaxProduct = b.AjaxProduct;
} else {
  takeOver('CartDrawer');
  takeOver('AjaxProduct');
}
})();
